import { Element } from '@chaysehartsuff/active-html';
import AloText from './AloText.js';
import AloModal from './AloModal.js';
import AloCheckbox from './AloCheckbox.js';
import PublicMessage from '../models/PublicMessage.js';
import {Dao} from '@chaysehartsuff/active-html';
import Message from './Message.js';
import ChatMessageInput from './ChatMessageInput.js';

/**
 * Public chatbox with real time updates
 */
export default class ChatBox extends Element {

    lastResultSize = 0;
    messageLimit = 10;
    messageLoadAmount = 10;
    reachedStart = false;

    /**
     * @type {Element} chatLog
     */
    chatLog;
    /**
     * @type {Element} name
     */ 
    name;
    /**
     * @type {ChatMessageInput} message
     */
    message;

    /**
     * @type {Element} messageCharacterCounter
     */
    messageCharacterCounter;

    /**
     * @type {Element} submitStatus
     */
    submitStatus;

    /**
     * @type {Element} submit
     */
    submit;
    
    /**
     * @type {Element} email
     */
    email;

    /**
     * 
     * @param {HTMLElement} element 
     */
    constructor(element) {
        super();
        let div = new Element()
            .addClass('w-full rounded-3xl border border-white/20 bg-black/55 p-4 backdrop-blur-sm flex flex-col')
            .setStyle('min-height', 'var(--feature-card-height)')
            ;

        this.subscribe_checkbox = new AloCheckbox();
        let subscribeToNewsletterCheckbox = new Element().addClass('flex items-start my-2 hidden')
            .addContent(new Element().addClass('text-sm ml-3').addContent('Subscribe to Newsletter'))
            .addContent(this.subscribe_checkbox.addClass('ml-4'));
        this.message = new ChatMessageInput();
        this.message.getTextarea()
            .addClass('w-full rounded-xl border border-white/15 bg-black/50 px-3 py-2 text-sm tracking-[0.08em] text-white placeholder:text-white/45 focus:border-emerald-300/60 focus:outline-none min-h-20')
            .setAttribute('placeholder', 'Message')
            .setAttribute('maxlength', 255)
            .onEvent('change', () => this.updateMessageCharacterCounter())
            .onEvent('input', () => this.updateMessageCharacterCounter());
        this.messageCharacterCounter = new Element()
            .addClass('text-xs text-white/45 text-right mt-1 hidden')
            .addContent('0/255');
        this.submitStatus = new Element()
            .addClass('text-xs text-left mt-1 ml-4 hidden');
        this.submit = new Element('button')
            .setAttribute('type', 'button')
            .addClass('w-full rounded-xl border border-emerald-200/30 bg-emerald-500/20 px-4 py-2 text-xs tracking-[0.18em] text-emerald-50 transition hover:bg-emerald-500/35 mt-2')
            .addContent('SEND MESSAGE')
            .onEvent('click', () => this.submitMessage());
        this.enable_notification_checkbox = new AloCheckbox();
        this.enable_notification_response = new Element('span')
            .addClass('hidden').addClass('my-2 ml-4 text-green-500 text-left text-sm block cursor-pointer hover:underline');

        this.chatLog = new Element()
            .addClass('mb-4 overflow-y-scroll rounded-2xl border border-white/10 bg-black/45 p-3 text-sm custom-scrollbar')
            .onEvent('scroll', () => this.onChatScroll())
            .setStyle('height', 'calc(var(--feature-card-height) - 15rem)');
        this.name = new AloText()
            .addClass('w-full rounded-xl border border-white/15 bg-black/50 px-3 py-2 text-sm tracking-[0.08em] text-white placeholder:text-white/45 focus:border-emerald-300/60 focus:outline-none mb-2')
            .setAttribute('placeholder', 'Your name');
        this.email = new AloText()
            .setAttribute('placeholder', 'Email')
            .addClass('my-2 text-sm')
            .onEvent('change', () => {
            let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            let email = this.email.getValue();
            if(emailRegex.test(email)){
                Dao.request('/subscribed/' + email, {}, (response) => {
                    let subscribed = response.subscribed;
                    if(subscribed){
                        subscribeToNewsletterCheckbox.addClass('hidden');
                    } else {
                        subscribeToNewsletterCheckbox.removeClass('hidden');
                    }
                }, 'GET');
            }
        });

        this.notify_div = new Element();
        this.notify_div
        .addContent(this.email)
        .addContent(subscribeToNewsletterCheckbox)
        .addClass('hidden');

        div.addContent(
            new Element().addClass('mb-4 flex items-center justify-between')
                .addContent(new Element().addClass('text-sm tracking-[0.2em] text-white').addContent('CHAT'))
                .addContent(new Element().addClass('text-[10px] tracking-[0.18em] text-emerald-100/80').addContent(''))
        );
        div.addContent(this.chatLog);
        div.addContent(
            new Element().addContent('')
        );
        div.addContent(this.name);
        div.addContent(this.message);
        div.addContent(this.messageCharacterCounter);
        div.addContent(this.submitStatus);
        this.enable_notification_box =  new Element().addClass('flex items-start my-4')
            .addContent(new Element().addContent('Enable reply notifications').addClass('text-sm ml-3'))
            .addContent(this.enable_notification_checkbox.addClass('ml-4')
                .addListener(AloCheckbox.onCheckedEvent, () => {
                    this.notify_div.removeClass('hidden');
                }).addListener(AloCheckbox.onUncheckedEvent, () => {
                    this.notify_div.addClass('hidden');
                })
            );
            div.addContent(this.enable_notification_box);
        div.addContent(this.enable_notification_response)
        div.addContent(this.notify_div);
        div.addContent(this.submit);
        this.addContent(div);

        if(element instanceof HTMLElement) {
            element.innerHTML = this.compile();
            this.bindEvents();
            this.refreshChatLog(false);
        }
        this.checkIfUserNotificationsEnabled();
        this.chatLogLoading = false;
    }

    submitMessage() {
        let publicMessage = new PublicMessage();
        publicMessage.name = this.name.getValue();
        publicMessage.message = this.message.getTextarea().getValue();

        if(this.message.getReplyMessage()?.publicMessage?.id){
            publicMessage.reply_to_id = this.message.getReplyMessage().publicMessage.id;
        }
        if(this.enable_notification_checkbox.checked()){
            publicMessage.email = this.email.getValue();
        }
        this.submit.addClass('cursor-not-allowed');
        this.submit.setAttribute('disabled', true);

        if(this.enable_notification_checkbox.checked()){
            this.enable_notification_checkbox.addClass('hidden');
        }

        publicMessage.create({subscribe: this.subscribe_checkbox.checked()}, (response) => {    
            if(response.hasOwnProperty('message')){
                this.submitStatus.removeClass('hidden').addClass('text-green-500').removeClass('text-red-500');
                this.submitStatus.setContent(response.message);
                this.submit.removeClass('cursor-not-allowed');
                this.submit.removeAttribute('disabled');
                this.wipeAndRefreshChatLog();
                this.message.getTextarea().clearContent();
                this.message.removeReplyMessage();
                this.email.clearContent();
                this.updateMessageCharacterCounter();
                this.enable_notification_checkbox.setChecked(false);
                this.notify_div.addClass('hidden');
            }
            if(response.hasOwnProperty('errors')){
                const firstErrorMessage = this.getFirstValidationError(response.errors);
                if(firstErrorMessage){
                    this.submitStatus.removeClass('hidden').addClass('text-red-500 ml-4').removeClass('text-green-500');
                    this.submitStatus.setContent(firstErrorMessage);
                }
                this.enable_notification_checkbox.removeClass('hidden');
            }
            this.submit.removeClass('cursor-not-allowed');
            this.submit.removeAttribute('disabled');
        });
    }

    updateMessageCharacterCounter() {
        let messageLength = this.message.getTextarea().getValue().length;
        this.messageCharacterCounter.setContent(messageLength + '/255');

        if(messageLength === 0){
            this.messageCharacterCounter.addClass('hidden');
        } else {
            this.messageCharacterCounter.removeClass('hidden');
        }
    }

    getFirstValidationError(errors) {
        if(!errors || typeof errors !== 'object'){
            return null;
        }

        for(const key of Object.keys(errors)){
            const value = errors[key];
            if(Array.isArray(value) && value.length > 0){
                return value[0];
            }
            if(typeof value === 'string' && value.length > 0){
                return value;
            }
        }

        return null;
    }

    refreshChatLog(scrollTop = true) {
        Dao.getAll(new PublicMessage(), (messages) => {
            // We request newest-first from the API and display oldest->newest in the UI.
            this.renderVisibleMessages({ scrollTop, messages: [...messages].reverse() });
            this.chatLogLoading = false;
            if(messages.length === this.lastResultSize){
                this.reachedStart = true;
            }
            this.lastResultSize = messages.length;
        }, {
            limit: this.messageLimit,
            reverse_order: 1
        });
    }

    renderVisibleMessages({ scrollTop = false, messages = [] } = {}) {
        const container = this.chatLog.bindedElement;
        const previousScrollTop = container ? container.scrollTop : 0;
        const previousScrollHeight = container ? container.scrollHeight : 0;

        this.chatLog.clearContent();

        for (const message of messages) {
            this.addMessage(new Message(message));
        }

        if (!container) {
            return;
        }

        if (!scrollTop) {
            container.scrollTop = container.scrollHeight;
            return;
        }

        if (scrollTop) {
            const nextScrollHeight = container.scrollHeight;
            const addedHeight = nextScrollHeight - previousScrollHeight;
            container.scrollTop = previousScrollTop + addedHeight + 10;
        }
    }

    onChatScroll() {
        const el = this.chatLog.bindedElement;
        const nearTopThreshold = 48;
        if (el.scrollTop > nearTopThreshold || this.chatLogLoading || this.reachedStart) {
            return;
        }
        this.messageLimit += this.messageLoadAmount;
        this.chatLogLoading = true;
        this.refreshChatLog();
    }

    wipeAndRefreshChatLog() {
        this.messageLimit = this.messageLoadAmount;
        this.lastResultSize = 0;
        this.reachedStart = false;
        this.chatLog.clearContent();
        this.chatLog.addContent(
            new Element()
                .addClass('text-xs text-white/45 tracking-[0.1em]')
                .addContent('Refreshing chat...')
        );
        this.refreshChatLog();
    }

    checkIfUserNotificationsEnabled() {
        Dao.request('/notifications/enabled', {}, (response) => {
            if(response.name){
                this.name.setValue(response.name);
            }
            if(response.enabled){
                this.enable_notification_response
                    .setContent("Notifications enabled ✔️")
                    .removeClass('hidden')
                    .onEvent('mouseover', () => {
                        this.enable_notification_response.setContent("Disable Notifications ❌")
                        .addClass('text-red-500').removeClass('text-green-500')
                        .onEvent('click', () => {
                            this.addContent(
                                new AloModal()
                                .addCardContent(new Element()
                                    .addClass('text-white')
                                    .addContent('Are you sure you want to disable notifications?')
                                    .addContent(
                                        new Element().addClass('flex justify-between gap-3 mt-4')
                                            .addContent(
                                                new Element('a')
                                                    .setAttribute('href', '/notifications/disable')
                                                    .addClass('flex-1 rounded-xl border border-red-500/40 bg-red-700/30 px-4 py-2 text-xs tracking-[0.18em] text-red-200 text-center transition hover:bg-red-700/50')
                                                    .addContent('Disable')
                                            )
                                            .addContent(
                                                new Element('button')
                                                    .setAttribute('type', 'button')
                                                    .addClass('flex-1 rounded-xl border border-white/20 bg-white/10 px-4 py-2 text-xs tracking-[0.18em] text-white transition hover:bg-white/20')
                                                    .addContent('Cancel')
                                                    .onEvent('click', () => this.removeContent('disable_notifications_modal'))
                                            )
                                    )
                                )
                            , 'disable_notifications_modal');
                        });
                        
                    })
                    .onEvent('mouseout', () => {
                        this.enable_notification_response.setContent("Notifications enabled ✔️")
                        .addClass('text-green-500').removeClass('text-red-500')
                        ;
                    });
                    ;
                this.enable_notification_box.addClass('hidden');
            } else {
               this.user_is_subscribed = false;
               this.enable_notification_response.addClass('hidden');
               this.enable_notification_box.removeClass('hidden');
            }
        }, 'GET');
    }

    /**
     * Adds a new message to the chat log with proper formatting
     * @param {Message} message 
     */
    addMessage(message) {
        this.chatLog.addContent(message);
        /** @var Message replyMessage */
        message.addListener(Message.onReplyEvent, (replyMessage) => {
            this.message.setReplyMessage(replyMessage);
        });
        this.chatLog.addContent(new Element().addClass('h-2'));
    }
}